import { Link } from 'react-router-dom';
import { Facebook, Youtube, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-black border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_faith-revamp-1/artifacts/q3zrx451_3D%20PNG.png"
                alt="True Believer"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              A new Non-Denominational church for a new time. Breaking traditional religious constraints by learning true scripture meaning of the WORD.
            </p>
            <Link
              to="/bible-app"
              data-testid="footer-get-app"
              className="inline-flex items-center gap-3 rounded-full border border-gold/40 bg-gold/5 py-2 pl-2 pr-5 transition-colors hover:border-gold hover:bg-gold/10"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_1c2b9578-16c6-47ba-a745-b83594265996/artifacts/esfzzpyh_The%20Holy%20WORD%20Bible%20icon%202%20%28512%20x%20512%20px%29%20%281%29.png"
                alt="The Holy WORD Bible app"
                className="w-10 h-10 rounded-lg border border-gold/30"
              />
              <span className="flex flex-col leading-tight">
                <span className="text-xs text-muted-foreground">Get the App</span>
                <span className="text-sm font-semibold text-gold">The Holy WORD Bible</span>
              </span>
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-cinzel text-gold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Media', 'Events', 'Donate'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase()}`}
                    className="text-muted-foreground hover:text-gold transition-colors text-sm"
                  >
                    {link}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/bible-app"
                  className="text-muted-foreground hover:text-gold transition-colors text-sm"
                >
                  Bible App
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-cinzel text-gold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Mail size={18} className="text-gold flex-shrink-0" />
                <a href="mailto:4thefam@truebelieverfam.com" className="hover:text-gold transition-colors">
                  4thefam@truebelieverfam.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Phone size={18} className="text-gold flex-shrink-0" />
                <a href="tel:281-914-0109" className="hover:text-gold transition-colors">
                  (281) 914-0109
                </a>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin size={18} className="text-gold flex-shrink-0 mt-0.5" />
                <div>
                  <p>10303 Northwest Freeway</p>
                  <p>Suite 263</p>
                  <p>Houston, TX 77092</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Social & Service Times */}
          <div>
            <h4 className="font-cinzel text-gold text-lg mb-6">Connect</h4>
            <div className="flex gap-4 mb-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:border-gold hover:text-gold transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:border-gold hover:text-gold transition-colors"
                data-testid="social-youtube"
                aria-label="YouTube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:border-gold hover:text-gold transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
            <div className="text-sm">
              <p className="text-muted-foreground mb-1">Service Times</p>
              <p className="text-foreground">Saturdays @ 9:45 AM CST</p>
              <p className="text-foreground">Wednesdays @ 7:00 PM CST</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {currentYear} True Believer. All rights reserved.
          </p>
          <p className="text-muted-foreground text-sm">
            501(c)(3) Certified Nonprofit Organization
          </p>
        </div>
      </div>
    </footer>
  );
};
